import { Link } from 'react-router-dom';
import type { Show } from '@/mocks/shows';

interface VideoCardProps {
  show: Show;
}

export default function VideoCard({ show }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${show.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200 mb-3">
        <img
          src={show.cover}
          alt={`${show.title} - 天狼影院高清在线观看`}
          title={`${show.title} - 天狼影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {show.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
              最新
            </span>
          )}
          {show.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-semibold rounded-md bg-background-950/70 text-primary-300 whitespace-nowrap">
            {show.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-background-50/90 line-clamp-2 leading-relaxed">
            {show.description}
          </p>
        </div>

        {show.status !== '已完结' && show.status !== '已上映' && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-background-300/40">
            <div
              className="h-full bg-primary-500 transition-all duration-300"
              style={{ width: `${(show.currentEpisode / show.episodeCount) * 100}%` }}
            ></div>
          </div>
        )}
      </div>

      <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 font-heading">
        {show.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
        {show.updateInfo}
      </p>
    </Link>
  );
}